/**
 * 基版コピー・フェーズ管理画面　基版コピー情報VOクラス
 */
export class KYMW2700CopyBasePageModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分

  public coopCode: string = null;                                               // 生協コード
  public pageNum: string = null;                                                // ページ番号
  public confirmFlag: string = null;                                            // 自動コマ配置実施確認フラグ(0：未確認、1：確認済)

}
